import { Settings } from "@/settings/settings";

export default class AppStorage {
    contentfulSpace = Settings.space;
    contentfulAccessToken = Settings.apiToken;
}
